var _style, _path, _path2, _path3, _path4, _circle, _circle2, _path5, _path6, _path7, _path8, _path9, _path10, _g, _path11, _circle3, _circle4, _rect, _circle5, _path12, _path13, _rect2, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _rect3, _rect4, _path25, _path26, _rect5, _rect6, _path27, _path28, _rect7, _rect8, _path29, _path30, _rect9, _rect10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRequestDemo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-49 159 512 476",
    style: {
      enableBackground: "new -49 159 512 476"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#C9DDFF;}\r\n\t.st1{fill:#A0BFF1;}\r\n\t.st2{fill:none;stroke:#F9A02B;stroke-width:3;stroke-opacity:0.5;}\r\n\t.st3{fill:none;stroke:#9EBCED;stroke-width:2;}\r\n\t.st4{fill:none;stroke:#F9A22D;stroke-width:2;}\r\n\t.st5{fill:none;stroke:#A0BFF1;}\r\n\t.st6{fill:#F9A12C;}\r\n\t.st7{fill:#F9A12C;fill-opacity:0.3;}\r\n\t.st8{fill:#C5D9FA;}\r\n\t.st9{fill:none;stroke:#F9A530;stroke-width:2;}\r\n\t.st10{fill:none;stroke:#F9A530;stroke-width:3;stroke-opacity:0.4;}\r\n\t.st11{fill:#E3E3E3;}\r\n\t.st12{fill:#FFFFFF;}\r\n\t.st13{fill:#EDEDED;}\r\n\t.st14{fill:#F4F7FC;}\r\n\t.st15{fill:#FFFFFF;stroke:#EDEDED;stroke-width:2;}\r\n\t.st16{fill:#FBB03B;}\r\n\t.st17{fill:#769CDC;}\r\n\t.st18{fill:none;}\r\n\t.st19{fill:#FFDFBA;}\r\n\t.st20{fill:#5881C7;}\r\n\t.st21{fill:#FFEBD2;}\r\n\t.st22{fill:#42434D;}\r\n\t.st23{fill:#FFD6A6;}\r\n\t.st24{fill:#4D4E59;}\r\n\t.st25{fill:#FFF3E4;}\r\n\t.st26{fill:#608BD2;}\r\n\t.st27{fill:#4772B9;}\r\n\t.st28{fill:#4C77BD;}\r\n\t.st29{fill:#DBE7FC;}\r\n\t.st30{fill:#A5BFEE;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M71.8,501.7c2.1-36.5-15.3-62.6-14.3-80.2c1-17.6,13.3-53.9,94.1-49.2s89.8,55.1,88.7,74.4 C235.1,537.3,68,566.3,71.8,501.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M396.5,249.9c-40.1-19.1-57.8-53.1-77.1-62.3c-19.3-9.2-65.3-17.5-107.7,71.6c-42.4,89,6,128.1,27.3,138.3 C338.6,444.9,467.6,283.7,396.5,249.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M26.4,406.2L11,383.3l27.5-1.9L26.4,406.2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M417.3,470.3l12.8-0.9l-5.6,11.5L417.3,470.3z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 73.5,
    cy: 301.5,
    r: 5.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 224.5,
    cy: 201.5,
    r: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M131,393c-0.6,0-1,0.4-1,1v5h-5c-0.6,0-1,0.4-1,1s0.4,1,1,1h5v5c0,0.6,0.4,1,1,1s1-0.4,1-1v-5h5 c0.6,0,1-0.4,1-1s-0.4-1-1-1h-5v-5C132,393.4,131.6,393,131,393z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M193.4,169.1c-0.5-0.5-1.4-0.5-1.9,0l-4.8,4.8l-4.8-4.8c-0.5-0.5-1.4-0.5-1.9,0c-0.5,0.5-0.5,1.4,0,1.9l4.8,4.8 l-4.8,4.8c-0.5,0.5-0.5,1.4,0,1.9c0.5,0.5,1.4,0.5,1.9,0l4.8-4.8l4.8,4.8c0.5,0.5,1.4,0.5,1.9,0c0.5-0.5,0.5-1.4,0-1.9l-4.8-4.8 l4.8-4.8C193.9,170.4,193.9,169.6,193.4,169.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M357,418c-0.3,0.3-0.3,0.8,0,1l2.6,2.6l-2.6,2.6c-0.3,0.3-0.3,0.8,0,1c0.3,0.3,0.8,0.3,1,0l2.6-2.6l2.6,2.6 c0.3,0.3,0.8,0.3,1,0c0.3-0.3,0.3-0.8,0-1l-2.6-2.6l2.6-2.6c0.3-0.3,0.3-0.8,0-1c-0.3-0.3-0.8-0.3-1,0l-2.6,2.6l-2.6-2.6 C357.8,417.8,357.3,417.8,357,418z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M412.1,204l2.5,9.8c0.1,0.5,0.6,0.8,1.1,0.7l8-1.3c0.5-0.1,1.1,0.3,1.2,0.8l1.3,8c0.1,0.5,0.5,0.9,1.1,0.8 l9.1-0.7c0.5,0,1,0.3,1.1,0.9l0.9,7.5c0.1,0.6,0.6,0.9,1.1,0.9l9.4-1.1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M-38.9,577.7l4.9-19.1c0.3-1,1.2-1.6,2.3-1.5l15.5,2.6c1.1,0.2,2.1-0.6,2.3-1.6l2.6-15.5 c0.2-1,1.1-1.7,2.1-1.7l17.7,1.3c1.1,0.1,2-0.7,2.1-1.8l1.7-14.6c0.1-1.1,1.1-1.9,2.2-1.8l18.4,2.2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M26,546h436c0.6,0,1,0.4,1,1l0,0c0,0.6-0.4,1-1,1H26c-0.6,0-1-0.4-1-1l0,0C25,546.4,25.4,546,26,546z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M180,212h122c16.6,0,30,13.4,30,30v313c0,16.6-13.4,30-30,30H180c-16.6,0-30-13.4-30-30V242 C150,225.4,163.4,212,180,212z"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M228,232h26c0.6,0,1,0.4,1,1l0,0c0,0.6-0.4,1-1,1h-26c-0.6,0-1-0.4-1-1l0,0C227,232.4,227.4,232,228,232z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 215,
    cy: 233,
    r: 3
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 241,
    cy: 223,
    r: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 252,
    className: "st14",
    width: 162,
    height: 277
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 240.5,
    cy: 556.5,
    r: 11.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M300.1,591.5c0-23.3-12.1-39.4-12.1-50.6s6.5-34.9,58.4-34.9c51.9,0,59.6,31.8,59.6,44.1 C406,608.1,300.1,632.8,300.1,591.5z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M88.3,220.8c24.2,0,40.8-10.8,52.5-10.8c11.7,0,36.2,5.8,36.2,52c0,46.2-33,53-45.8,53 C71.1,315,45.4,220.8,88.3,220.8z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 198,
    className: "st18",
    width: 118,
    height: 93
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M385.9,575.1v8.4c0,0.9-0.8,1.7-1.7,1.7h-62.4c-0.9,0-1.7-0.8-1.7-1.7v-8.4c0-6.5,3.8-12,9.4-14.5 c-2.3-1.8-5.7-4.2-8.2-9.4c-3.5-7.2-2.9-15.7,1.5-22.4c2.4-3.6,3.7-7.9,3.7-12.2v-9.3c0-11.8,9.6-21.4,21.4-21.4h10.3 c11.8,0,21.4,9.6,21.4,21.4c0,9.8-0.2,11.7,0.9,15.6c1.7,5.5,3.9,6.2,5.6,11.8c2.7,8.8-0.3,18.5-7.6,24.2l-1.9,1.5 C382.1,563.1,385.9,568.7,385.9,575.1z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M385.9,575.1v8.4c0,0.9-0.8,1.7-1.7,1.7h-62.4c-0.9,0-1.7-0.8-1.7-1.7v-8.4c0-8.8,7.1-15.9,15.9-15.9 c1.3,0,2.6-0.3,3.7-0.8l0.1,0.1l12.2,9.5c0.6,0.5,1.5,0.5,2.1,0l12.2-9.5l0.1-0.1c1.1,0.5,2.4,0.8,3.7,0.8 C378.8,559.2,385.9,566.3,385.9,575.1z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M372.5,517.3c0.9,0.1,1.6,0.8,1.6,1.7v10.2c0,8.8-5.4,16.4-13.1,19.6c-13.9,5.8-29.3-4.5-29.3-19.6v-10.1 c0-1,0.9-1.8,1.9-1.7c10.3,0.9,20.4-1.7,28.9-7.4c1-0.6,2.3-0.2,2.6,1C366.2,514.9,369.1,517.1,372.5,517.3z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M378.5,559.1l-1.9,1.5c-2-0.9-4.2-1.4-6.6-1.4c-4.9,0-8.9-3.9-8.9-8.8v-1.5l0-0.1c7.7-3.2,13.1-10.7,13.1-19.6 V519c0-0.9-0.7-1.7-1.6-1.7c-3.5-0.2-6.4-2.4-7.4-6.3c-0.3-1.1-1.6-1.6-2.6-1c-8.5,5.7-18.6,8.3-28.9,7.4c-1-0.1-1.9,0.7-1.9,1.7 v10.1c0,8.8,5.4,16.4,13.1,19.6l0,0.1v1.5c0,4.9-4,8.8-8.9,8.8c-2.4,0-4.6,0.5-6.6,1.4l-1.9-1.5c-9.2-7.3-11.2-20.5-4.7-30.2 c2.4-3.6,3.7-7.9,3.7-12.2v-9.3c0-11.8,9.6-21.4,21.4-21.4h10.3c11.8,0,21.4,9.6,21.4,21.4v9.3c0,4.3,1.3,8.6,3.7,12.2 C389.7,538.7,387.6,551.8,378.5,559.1z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M361.4,552.4c-5.3,2.2-11.1,2.4-16.7,0c0.3-1.2,0.2-2,0.2-3.5l0-0.1c5.1,2.1,11,2.1,16.2,0l0,0.1 C361.1,550.4,361.1,551.2,361.4,552.4z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M367.8,488.3c2.2,1.1,1.2,4.4-1.2,4.2c-0.7-0.1-1.4-0.1-2-0.1h-10.3c-11.8,0-21.4,9.6-21.4,21.4v2.6 c0,1.5-1.1,1.5-1.1,2.7c0,11.3,0,10.6-0.1,11.1c-1.7,4.9-3.7,5.6-5.3,11c-0.9,2.9-1.2,6-0.8,8.9c0.3,2.4-3.1,3.5-4.3,1 c-3.5-7.2-2.9-15.7,1.5-22.4c2.4-3.6,3.7-7.9,3.7-12.2v-9.3c0-11.8,9.6-21.4,21.4-21.4h10.3C361.6,486,364.9,486.8,367.8,488.3z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M348.9,543.4c3.2,2.1,0.8,7.1-2.9,5.8c-8-2.8-14.2-10.2-14.2-20v-10.1c0-1,0.9-1.8,1.9-1.7 c0.8,0.1,1.7,0.1,2.7,0.2c1.8,0.1,3.1,1.5,3.1,3.3v4.9C339.5,533.2,343.3,539.6,348.9,543.4z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M343.3,561.2c1,0.8,0.5,2.4-0.8,2.4c-9.1,0-16,7.3-16,15.9v5.6h-4.7c-0.9,0-1.7-0.8-1.7-1.7v-8.4 c0-8.8,7.1-15.9,15.9-15.9c1.3,0,2.6-0.3,3.7-0.8l0.1,0.1L343.3,561.2z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M362.7,561.2c-1,0.8-0.5,2.4,0.8,2.4c9.1,0,16,7.3,16,15.9v5.6h4.7c0.9,0,1.7-0.8,1.7-1.7v-8.4 c0-8.8-7.1-15.9-15.9-15.9c-1.3,0-2.6-0.3-3.7-0.8l-0.1,0.1L362.7,561.2z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M183,287h106c5.5,0,10,4.5,10,10v23c0,5.5-4.5,10-10,10h-96c-5.5,0-10-4.5-10-10V287z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M168.5,287H185v11L168.5,287z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 302,
    className: "st28",
    width: 84,
    height: 3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 313,
    className: "st28",
    width: 37,
    height: 3
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M183,397h106c5.5,0,10,4.5,10,10v23c0,5.5-4.5,10-10,10h-96c-5.5,0-10-4.5-10-10V397z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M168,397h16.5v11L168,397z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 412,
    className: "st28",
    width: 84,
    height: 3
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 423,
    className: "st28",
    width: 37,
    height: 3
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M299,342H193c-5.5,0-10,4.5-10,10v23c0,5.5,4.5,10,10,10h96c5.5,0,10-4.5,10-10V342z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M313.5,342H297v11L313.5,342z"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 357,
    className: "st30",
    width: 84,
    height: 3
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 368,
    className: "st30",
    width: 37,
    height: 3
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M299,452H193c-5.5,0-10,4.5-10,10v23c0,5.5,4.5,10,10,10h96c5.5,0,10-4.5,10-10V452z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M313,452h-16.5v11L313,452z"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 467,
    className: "st30",
    width: 84,
    height: 3
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 478,
    className: "st30",
    width: 37,
    height: 3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestDemo);
export default __webpack_public_path__ + "static/media/request-demo.4851388f4a9d8e1f31c17efa4fb5aaba.svg";
export { ForwardRef as ReactComponent };